import { format } from "date-fns";

export function formatDateDayOnly(date: string | Date): string {
  const d = new Date(date);
  return format(d, "MMMM d");
}
